/**
 * Higher Order Component to fix iOS fixed elements
 *
 * Use absolute positioning on iOS because
 * fixed elements are uncontrolabbly transformed in absolute
 * when virtual keyboard appear. So use it only when it make sense.
 */
import * as React from "react";
import * as ReactDOM from "react-dom";

interface IOSFixFixedProps extends React.Props<IOSFixFixed> {
    children?: JSX.Element;
}

interface DelayedState {
    renderChildren: boolean;
}

export class IOSFixFixed extends React.Component<IOSFixFixedProps, DelayedState> {

    private isIOS = false;
    private topOffset = 0;

    constructor(props: IOSFixFixedProps) {
        super(props);
        this.isIOS = /(iPad|iPhone|iPod)/.test(navigator.userAgent)
            // Exclude IE11 on Windows 8 Mobile, that has "like iPhone" in userAgent
            && !/IEMobile/.test(navigator.userAgent);
    }

    render() {
        return this.props.children;
    }

    componentDidMount() {
        if (this.isIOS) {
            window.addEventListener('scroll', this.syncTop);
            window.addEventListener('resize', this.syncTop);
            this.fixedToAbsolute();
        }
    }

    componentDidUpdate() {
        if (this.isIOS) {
            this.fixedToAbsolute();
        }
    }

    componentWillUnmount() {
        if (this.isIOS) {
            window.removeEventListener('scroll', this.syncTop);
            window.removeEventListener('resize', this.syncTop);
            this.absoluteToFixed();
        }
    }

    private syncTop = () => {
        const rootEl = ReactDOM.findDOMNode(this) as HTMLElement;
        const docRect = document.documentElement.getBoundingClientRect();
        rootEl.style.top = (this.topOffset - docRect.top) + 'px';
    }

    private fixedToAbsolute = () => {
        const rootEl = ReactDOM.findDOMNode(this) as HTMLElement;
        if (rootEl.style.position === 'fixed') {
            this.topOffset = parseInt(rootEl.style.top, 10);
        }
        rootEl.style.position = 'absolute';
        this.syncTop();
    }

    private absoluteToFixed = () => {
        const rootEl = ReactDOM.findDOMNode(this) as HTMLElement;
        rootEl.style.position = 'fixed';
        rootEl.style.position = this.topOffset + 'px';
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/IOSFixFixed.tsx
 **/